export const FIELD_VALUE_TYPE = {
  BOOLEAN: 'boolean',
  ALPHANUMERIC: 'alphanumeric',
  NUMBERIC: 'numeric',
};

export const FIELD_VALUE_TYPE_LABEL: Record<string, string> = {
  [FIELD_VALUE_TYPE.BOOLEAN]: 'Booleano',
  [FIELD_VALUE_TYPE.ALPHANUMERIC]: 'Texto',
  [FIELD_VALUE_TYPE.NUMBERIC]: 'Numérico',
}
